import {
  isInsideAndroidWebView,
  isInsideIOSWebKit,
} from "src/pageDefinitions/goto/utils";
import { captureException } from "src/utils/error";
import {
  getAndroidMessageHandlers,
  getAndroidTelehealthMessageHandlers,
  getIOSMessageHandlers,
  getIOSTelehealthMessageHandlers,
} from "src/utils/in-app/messageHandlers";

export default {
  webviewExit: () => {
    /*
      Note(AndiRayhan): Why I'm not using nativeWebviewExit? The Android telehealth
      webview does not seem to like it when we assign the webviewExit
      function to a local variable. I didn't want to change nativeWebviewExit
      because it has other usages, so I decided to create a separate function for
      the telehealth webview
    */
    if (isInsideIOSWebKit()) {
      const webviewExit = getIOSMessageHandlers()?.webviewExit;
      webviewExit?.postMessage({});
      return !!webviewExit;
    }
    if (isInsideAndroidWebView()) {
      if (getAndroidMessageHandlers()?.webviewExit) {
        getAndroidMessageHandlers()?.webviewExit();
      }
      return !!getAndroidMessageHandlers()?.webviewExit;
    }
    return false;
  },
  taskComplete: () => {
    try {
      if (isInsideIOSWebKit()) {
        const telehealthTaskComplete =
          getIOSTelehealthMessageHandlers()?.taskComplete;
        telehealthTaskComplete?.postMessage({});
        return !!telehealthTaskComplete;
      }

      if (isInsideAndroidWebView()) {
        // The telehealth webview doesn't like it when
        // we assign the Java bridge function to a variable :/
        // so having to refer to it directly like this in multiple places
        if (getAndroidTelehealthMessageHandlers()?.taskComplete) {
          getAndroidTelehealthMessageHandlers()?.taskComplete();
        }
        return !!getAndroidTelehealthMessageHandlers()?.taskComplete;
      }

      return false;
    } catch (err) {
      captureException(err);
      return false;
    }
  },
  taskSkipped: () => {
    try {
      if (isInsideIOSWebKit()) {
        const telehealthTaskSkipped =
          getIOSTelehealthMessageHandlers()?.taskSkipped;
        telehealthTaskSkipped?.postMessage({});
        return !!telehealthTaskSkipped;
      }

      if (isInsideAndroidWebView()) {
        // The telehealth webview doesn't like it when
        // we assign the Java bridge function to a variable :/
        // so having to refer to it directly like this in multiple places
        if (getAndroidTelehealthMessageHandlers()?.taskSkipped) {
          getAndroidTelehealthMessageHandlers()?.taskSkipped();
        }
        return !!getAndroidTelehealthMessageHandlers()?.taskSkipped;
      }

      return false;
    } catch (err) {
      captureException(err);
      return false;
    }
  },
};
